module.exports = "/_next/static/images/youtube-negative-80d71de1dcf89b106507078bf498c851.png";